// スクロールアクション用（.js-target が画面に入ったら .on を付ける）
//
// 2026-08-27 改善: 以前は「ページのどこかが少しでも変わるたびに、監視を全部外して
// ページ全体を数え直し、全要素を登録し直す」作りだった。アプリ（お気に入り・レビュー等）が
// 要素を大量に差し込むため何百回も発火し、モバイル8ページ合計で735msの固まり時間を
// 出していた（PageSpeed実測、当社ファイル由来の長タスクはこの1ファイルのみ）。
//
// 変更点は3つ。見た目と動きは同じ:
//   1. 変更通知をまとめてから1回だけ処理する（連続した差し込みを1回に畳む）
//   2. すでに監視中の要素は登録し直さない（登録済みを覚えておく）
//   3. .on が付いた要素は監視から外す（付いたら二度と外れないため、見続ける必要がない）
const NICOMO_SCROLL_SELECTOR = ".js-target";
const nicomoObserved = new WeakSet();

const nicomoScrollObserver = new IntersectionObserver(
  function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("on");
        // 一度 .on が付いたら外れないので、監視を解除して以後の処理を減らす
        nicomoScrollObserver.unobserve(entry.target);
      }
    });
  },
  { root: null, threshold: 0.4 },
);

function nicomoRegisterTargets() {
  document.querySelectorAll(NICOMO_SCROLL_SELECTOR).forEach(function (target) {
    if (nicomoObserved.has(target)) return;
    nicomoObserved.add(target);
    nicomoScrollObserver.observe(target);
  });
}

nicomoRegisterTargets();

// DOM の変更をまとめてから1回だけ登録し直す
let nicomoScanScheduled = false;
function nicomoScheduleScan() {
  if (nicomoScanScheduled) return;
  nicomoScanScheduled = true;
  const run = function () {
    nicomoScanScheduled = false;
    nicomoRegisterTargets();
  };
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(run, { timeout: 500 });
  } else {
    setTimeout(run, 200);
  }
}

const nicomoTargetMutationObserver = new MutationObserver(function (mutations) {
  // 要素が増えた通知だけを対象にする（属性やテキストの変化では走らせない）
  for (let i = 0; i < mutations.length; i++) {
    if (mutations[i].addedNodes.length > 0) {
      nicomoScheduleScan();
      return;
    }
  }
});

nicomoTargetMutationObserver.observe(document.body, {
  childList: true,
  subtree: true,
});
